export default __webpack_public_path__ + "static/media/n11.279a3c58.svg";